import React from 'react'

const AddAsigneeButton = props => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect x='0.5' y='0.5' width='19' height='19' rx='3.5' fill='#F5F6F8' />
    <rect x='0.5' y='0.5' width='19' height='19' rx='3.5' stroke='#888888' />
    <path
      d='M6 10H14'
      stroke='#404040'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M10 14V6'
      stroke='#404040'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default AddAsigneeButton
